import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import shortid from 'shortid';
import classnames from 'classnames';

type ItemID = any;

export type CheckboxListProps<T> = {    
    dataSource: T[],
    renderItem: (item: T) => React.ReactNode;
    onSelectedItemChanged?: (selectedItem: T, checked: boolean) => void;
    getId: (item: T) => ItemID;
    selectedValues: ItemID[];
    className?: string;
    inlineStyle?: boolean;
}

function CheckboxList<T>(props: CheckboxListProps<T>) {

    const [idPrefix] = useState(shortid.generate());

    useEffect(() => {


    }, []);


    // end autocomplete
    return (<React.Fragment>
        <ul className={classnames("checkbox-list", props.className, (props.inlineStyle == true ? 'checkbox-list-inline' : ''))}>
            {props.dataSource.map((item) =>
                <li key={props.getId(item)}>
                    <input type="checkbox" id={`${idPrefix}_${props.getId(item)}`}
                        onChange={(e) => props.onSelectedItemChanged(item, e.target.checked)}
                        checked={props.selectedValues.indexOf(props.getId(item)) > -1}
                    />
                    <label htmlFor={`${idPrefix}_${props.getId(item)}`}>{props.renderItem(item)}</label>
                </li>
            )}
        </ul>
    </React.Fragment>);
}

export default CheckboxList;